"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var index_1 = require("./index");
var utils_1 = require("./utils");
var lodash_1 = require("lodash");
var PresenterInterceptor = /** @class */ (function () {
    function PresenterInterceptor(passport, options) {
        this.passport = passport;
        this.options = options;
        this.clientUnauthorized = false;
        this.preventPreReqestsRetry = false;
        this.newRequestRetardation = Promise.resolve();
        this.needPaymentRequestRetardation = Promise.resolve();
        this.needMfaRequestRetardation = Promise.resolve();
        this.onPaymentWait = false;
        this.onMfaWait = false;
    }
    PresenterInterceptor.prototype.promise = function () {
        return Promise.all([this.newRequestRetardation, this.needPaymentRequestRetardation, this.needMfaRequestRetardation]);
    };
    PresenterInterceptor.prototype.processRespondAsUnauthorized = function (err, requester) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.clientUnauthorized) {
                            this.passport.expireToken('token');
                            this.clientUnauthorized = true;
                            this.newRequestRetardation = (0, index_1.prepareAccess)([constants_1.ERROR_TYPE.AUTH, constants_1.ERROR_TYPE.PAYMENT])
                                .then(function (d) {
                                _this.clientUnauthorized = false;
                            })
                                .catch(function (err) {
                                if (err.resetRetardation) {
                                    _this.clientUnauthorized = false;
                                }
                                return Promise.reject(err);
                            })
                                .then(function () {
                                try {
                                    _this.options.onTokenRefresh(err);
                                }
                                catch (e) {
                                    _this.preventPreReqestsRetry = true;
                                }
                            });
                        }
                        return [4 /*yield*/, this.promise()];
                    case 1:
                        _a.sent();
                        if (this.clientUnauthorized) {
                            throw new Error('request cancelled');
                        }
                        if (this.preventPreReqestsRetry) {
                            this.preventPreReqestsRetry = false;
                            return [2 /*return*/, Promise.reject(err)];
                        }
                        return [4 /*yield*/, requester.request(err.config)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PresenterInterceptor.prototype.detectResponseAsRequirePayment = function (err) {
        return err.response && err.response.status === constants_1.USER_NEED_PAYMENT_HTTP_CODE;
    };
    PresenterInterceptor.prototype.processRespondAsRequirePayment = function (err, requester) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.onPaymentWait) {
                            this.onPaymentWait = true;
                            this.needPaymentRequestRetardation = (0, utils_1.promisify)(this.options.onPaymentRequired(err))
                                .then(function () {
                                _this.passport.expireToken('token');
                                return (0, utils_1.waitJumpout)();
                            })
                                .finally(function () { return _this.onPaymentWait = false; });
                        }
                        return [4 /*yield*/, this.promise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.reject(err)];
                }
            });
        });
    };
    PresenterInterceptor.prototype.processRespondAsRequireMfa = function (err, requester) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.onMfaWait) {
                            this.onMfaWait = true;
                            this.needMfaRequestRetardation = (0, utils_1.promisify)(this.options.onMfaRequired(err))
                                .then(function () {
                                _this.passport.expireToken('token');
                                return (0, utils_1.waitJumpout)();
                            })
                                .finally(function () { return _this.onMfaWait = false; });
                        }
                        return [4 /*yield*/, this.promise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.reject(err)];
                }
            });
        });
    };
    PresenterInterceptor.prototype.processRespond = function (err, requester) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.options.detectResponseAsUnauthorized(err)) {
                    return [2 /*return*/, this.processRespondAsUnauthorized(err, requester)];
                }
                if (this.detectResponseAsRequirePayment(err)) {
                    return [2 /*return*/, this.processRespondAsRequirePayment(err, requester)];
                }
                if (this.detectResponseAsRequireMfa(err)) {
                    return [2 /*return*/, this.processRespondAsRequireMfa(err, requester)];
                }
                return [2 /*return*/, Promise.reject(err)];
            });
        });
    };
    PresenterInterceptor.prototype.detectResponseAsRequireMfa = function (err) {
        // 检测HTTP状态码403和MFA错误码
        var isHttp403 = err.response && err.response.status === constants_1.USER_NEED_MFA_HTTP_CODE;
        var errorCode = (0, lodash_1.get)(err, 'errcode') || (0, lodash_1.get)(err, 'response.data.errcode');
        var isMfaErrorCode = errorCode && (0, lodash_1.includes)((0, lodash_1.values)(constants_1.NEED_MFA_ERROR_CODES), errorCode);
        return isHttp403 && isMfaErrorCode;
    };
    return PresenterInterceptor;
}());
exports.default = PresenterInterceptor;
//# sourceMappingURL=interceptor.js.map